import React, {useState} from "react";
import {Button, Modal, Form} from "react-bootstrap";
import FalconCloseButton from "../../common/FalconCloseButton";
import {useForm} from "react-hook-form";
import { faXmarkCircle } from "@fortawesome/free-solid-svg-icons";
import IconButton from "../../common/IconButton";
import { useSelector } from "react-redux";
import { selectLang, Translate } from "../../../app/store/reducers/main/mainReducer";


const DeclineInvoice = ({cancelInvoiceHandler, disabled, ...props}) => {
    const {register, formState: {errors}, handleSubmit, reset} = useForm();
    const lang = useSelector(selectLang);
    const t = Translate;

    const [show, setShow] = useState(false);
    const handleClose = () => {
        reset();
        setShow(false);
    };

    const formSubmit = ({comment}) => {
        cancelInvoiceHandler({
            comment: comment
        })
        reset();
        setShow(false);
    };

    return (
        <>
        <IconButton
            variant="falcon-danger"
            size="sm"
            icon={faXmarkCircle}
            disabled={disabled}
            iconClassName="me-1"
            onClick={() => {
                console.log("AAA")
                setShow(true)
            }}
            {...props}
        >{t(lang, "edi.common.button.decline")}</IconButton>
            <Modal size="md" show={show} onHide={handleClose}>
                <Form onSubmit={handleSubmit(formSubmit)}>
                    <Modal.Header>
                        <Modal.Title>Invoice decline</Modal.Title>
                        <FalconCloseButton onClick={() => {handleClose()}}/>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group>
                            <Form.Label>Comment</Form.Label>
                            <Form.Control
                                name="Name"
                                as="textarea" rows={3}
                                placeholder="Please enter a comment to decline"
                                isInvalid={errors?.comment?.message}
                                {...register("comment", {
                                    required: {
                                        value: true,
                                        message: "This field is required!"
                                    }
                                })}
                            />
                            <Form.Control.Feedback type="invalid">
                                {errors?.comment?.message}
                            </Form.Control.Feedback>
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => {handleClose()}}>{t(lang, "edi.common.button.close")}</Button>
                        <Button
                            variant="danger"
                            className="d-flex align-items-center"
                            disabled={disabled}
                            type="submit"
                        >{t(lang, "edi.common.button.yes")}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </>
    )
}

export default DeclineInvoice;
